"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This class contains the default control and container elements
 */
var Defaults = /** @class */ (function () {
    function Defaults() {
    }
    /**
     * @return the default textbox: .lto-textbox
     */
    Defaults.textbox = function () {
        if (document.getElementsByClassName("lto-textbox").length === 0) {
            throw new Error("no default element with class 'lto-textbox' found");
        }
        return document.getElementsByClassName("lto-textbox")[0];
    };
    /**
     * @return the default autocomplete dropdown: .lto-autocomplete
     */
    Defaults.autocomplete = function () {
        if (document.getElementsByClassName("lto-autocomplete").length === 0) {
            throw new Error("no default element with class 'lto-autocomplete' found");
        }
        return document.getElementsByClassName("lto-autocomplete")[0];
    };
    /**
     * @return the default invoker: .lto-invoker
     */
    Defaults.invoker = function () {
        if (document.getElementsByClassName("lto-invoker").length === 0) {
            throw new Error("no default element with class 'lto-invoker' found");
        }
        return document.getElementsByClassName("lto-invoker")[0];
    };
    /**
     * @return the default content container: .lto-content
     */
    Defaults.content = function () {
        if (document.getElementsByClassName("lto-content").length === 0) {
            throw new Error("no default element with class 'lto-content' found");
        }
        return document.getElementsByClassName("lto-content")[0];
    };
    /**
     * @return the default suggestion container: .lto-suggest
     */
    Defaults.suggest = function () {
        if (document.getElementsByClassName("lto-suggest").length === 0) {
            throw new Error("no default element with class 'lto-suggest' found");
        }
        return document.getElementsByClassName("lto-suggest")[0];
    };
    return Defaults;
}());
exports.Defaults = Defaults;
